export const SET_NUMBERS = 'SET_NUMBERS'
export const RESET_NUMBERS = 'RESET_NUMBERS'
